
import { Row, Col, Panel, ButtonToolbar, Notification, useToaster , Drawer, Button } from "rsuite"
import { Icon } from '@rsuite/icons';
import SettingIcon from '@rsuite/icons/Setting';
import FunnelIcon from '@rsuite/icons/Funnel';
import * as linkIcon from '@fortawesome/free-solid-svg-icons/faArrowUpRightFromSquare';

import BriefCreateForm from "./briefCreateForm";
import { clearPreviousEdit } from "./briefLocalStorageManager";
import { useEffect, useState } from "react";
import useLocalStorage from "../../hooks/useLocalStorage";

const FaSvgIcon = ({ faIcon, ...rest }) => {
    const { width, height, svgPathData } = faIcon;
    return (
      <svg {...rest} viewBox={`0 0 ${width} ${height}`} width="1em" height="1em" fill={rest.color}>
        <path d={svgPathData}></path>
      </svg>
    );
  }

export function copyLink(brief_id, toaster) {
    navigator.clipboard.writeText(`${window.location.origin}/view/${brief_id}`);

    toaster.push(
        <Notification type={'info'} header={"Ссылка скопирована"} style={{width: '25rem'}}>
            <p>Скопировано в буффер обмена</p>
            <hr/>
            <div style={{display: 'flex', justifyContent: 'flex-end', width: '100%'}}>
                <Button endIcon={<Icon as={FaSvgIcon} color="#fff" faIcon={linkIcon} />} appearance="primary" onClick={
                    () => {
                        window.open(`${window.location.origin}/view/${brief_id}`);
                    }
                }>Перейти</Button>
            </div>
            
        </Notification>,
        {placement: 'bottomStart', duration: 5000}
    );
}

export default function BriefDrawerFooter({setOpen, updateBriefs}) {
    const toaster = useToaster();
    const [updater, setUpdater] = useState(0);

    useEffect(() => {
        setTimeout(() => {
            setUpdater(updater + 1);
        }, 1000)
    }, [updater])


    return (
        <div style={
            {
                display: 'flex',
                justifyContent: 'flex-end',
                width: '100%',
                height: '100%',
            }
        }>
            <Button color="green" appearance="primary" onClick={() => {
                setOpen(false);
                updateBriefs();
            }}>
                Принять
            </Button>
            {localStorage.getItem('brief:current_edit_key') &&
                <Button onClick={() => {
                    copyLink(localStorage.getItem('brief:current_edit_key'), toaster);
                }}>Копировать ссылку</Button>
            }
        </div>
    )
}
